import { graphql } from "babel-plugin-relay/macro";

export const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment contentSubmissionNavigation_ContentSubmissionFragment on ContentSubmission {
		id
		definition {
			... on ELearningContentSubmissionDefinition {
				progress {
					percentage
				}
				status
			}
		}
		learnOpportunity {
			id
			root {
				id
				structureDefinition {
					... on LearnOpportunityRootStructureDefinition {
						viewerTreeState {
							kind
						}
						extension {
							... on PublishedRootExtensionImpl {
								cartClickout {
									relativeLink
								}
								unlockInfo {
									kind
								}
								ihkState
								extension {
									... on PublishedConstellationRootExtensionExtension {
										licenseAvailability {
											... on LicenseAvailabilityFreeLicensesAvailable {
												numAvailable
											}
										}
									}
								}
							}
						}
					}
				}
			}
			typeDefinition {
				... on LearnOpportunityContentTypeDefinition {
					contentNodeAdvancementResult {
						status
					}
				}
			}
			nextContentNodeId
			nextContentNode {
				typeDefinition {
					... on LearnOpportunityELearningContentTypeDefinition {
						extension {
							... on LearnContentExtensionImpl {
								isUnlockNecessaryToStart
							}
						}
					}
					... on LearnAsyncContentTypeDefinition {
						extension {
							... on LearnContentExtensionImpl {
								isUnlockNecessaryToStart
							}
						}
					}
				}
			}
		}

		...GoToPreviousElementButton_ContentSubmissionFragment
		...GoToNextElementButton_ContentSubmissionFragment
	}
`;

export const RESTART_CONTENT_NODE_AFTER_PASSED_MUTATION = graphql`
	mutation contentSubmissionNavigation_RestartContentNodeAfterPassedMutation(
		$input: RestartContentNodeAfterPassedInput!
	) {
		LearnV2 {
			restartContentNodeAfterPassed(input: $input) {
				clientMutationId
				contentSubmission {
					id
				}
			}
		}
	}
`;

export const RESTART_CONTENT_NODE_AFTER_FAILED_MUTATION = graphql`
	mutation contentSubmissionNavigation_RestartContentNodeAfterFailedMutation(
		$input: RestartContentNodeAfterFailedInput!
	) {
		LearnV2 {
			restartContentNodeAfterFailed(input: $input) {
				clientMutationId
				contentSubmission {
					id
				}
			}
		}
	}
`;

export const QUERY = graphql`
	query contentSubmissionNavigation_Query {
		Viewer {
			Auth {
				...profileMenu_AuthViewerSchemaFragment
			}
		}
	}
`;

export const BOOK_TREE_MUTATION = graphql`
	mutation contentSubmissionNavigation_BookTreeMutation($input: BookTreeInput!) {
		Billing {
			bookTree(input: $input) {
				clientMutationId
				root {
					...advanceTreeNavigation_LearnOpportunityV2Fragment
				}
			}
		}
	}
`;
